import React from 'react'
import "./howitWorks.css"
import Glidar from '../../../components/Glidar'
import Floater from '../../../components/Floaters/Floater'

function InvestorPartner() {
  const HotelsClientArr = [
      "../../../../img/pvt_investors/p_investor_1.webp",
      
  ]
  const Pvt_InvestorArr = [
      "../../../../img/pvt_investors/p_investor_1.webp",
      "../../../../img/pvt_investors/p_investor_2.webp",
      "../../../../img/pvt_investors/p_investor_16.webp",
      "../../../../img/pvt_investors/p_investor_4.webp",
      "../../../../img/pvt_investors/p_investor_5.webp",
      "../../../../img/pvt_investors/p_investor_6.webp",
      "../../../../img/pvt_investors/p_investor_7.webp",
      "../../../../img/pvt_investors/p_investor_8.webp",
      "../../../../img/pvt_investors/p_investor_9.webp",
      "../../../../img/pvt_investors/p_investor_10.webp",
      "../../../../img/pvt_investors/p_investor_11.webp",
      "../../../../img/pvt_investors/p_investor_12.webp",
      "../../../../img/pvt_investors/p_investor_13.webp",
      "../../../../img/pvt_investors/p_investor_14.webp",
      "../../../../img/pvt_investors/p_investor_15.webp",
  ]

  const banksArr = [
      "../../../../img/banks/bank_1.webp",
      "../../../../img/banks/bank_2.webp",
      "../../../../img/banks/bank_3.webp",
      // "../../../../img/banks/bank_4.webp",
      "../../../../img/banks/bank_5.webp",
      "../../../../img/banks/bank_6.webp",
      "../../../../img/banks/bank_7.webp",
      // "../../../../img/banks/bank_8.webp",
      // "../../../../img/banks/bank_9.webp",
      // "../../../../img/banks/bank_10.webp",
      // "../../../../img/banks/bank_11.webp",
      // "../../../../img/banks/bank_12.webp",
      // "../../../../img/banks/bank_13.webp",
      "../../../../img/banks/bank_14.webp",
      // "../../../../img/banks/bank_15.webp",
      "../../../../img/banks/bank_16.webp",

  ]

return (
  <div id='InvestorPartner' className='clientSection'>


<div className='client-scroller-wp'>
  <div className='header'>
      <h1 className='text'>Our Partners</h1>
  </div>
  <Glidar animationDuration={banksArr?.length+"s"} title={"Banks"} content={banksArr} headerColor={"linear-gradient(to bottom right, #32d6fb 0%, #5558ed 100%)"} style={{marginTop: "50px"}} />
  <Glidar animationDuration={Pvt_InvestorArr?.length+"s"} title={"Private Investor"} content={Pvt_InvestorArr} headerColor={"linear-gradient(to bottom right, #1cf196 0%, #36a6bf 100%)"} style={{marginTop: "50px"}} />
</div>

  </div>
)
}

function HowitWorks() {
    return (
        <section className='investers-section'>
        <Floater />
            {/* <p className='text'>We provide everything you need to fulfill your orders, from <b>licenses</b> to a <b>professional website</b> and even <b>initial investment</b>. We are connected with <b>8 banks</b> and over <b>50 private investors</b> to manage all the financial requirements for your <span className='no-line-break'>export-import orders.</span></p> */}
            <div id='InvestorPartner' className='clientSection'>


<div className='client-scroller-wp'>
  <div className='header'>
      <h1 className='text'>How it works</h1>
  </div>
  <div style={{marginTop: "50px"}} className='glidar'>
            <div style={{background: "linear-gradient(to bottom right, #32d6fb 0%, #5558ed 100%)"}} className='header'>
                <h4>{"Step 1"}</h4>
            </div>
            <div className=''>
                <p className='text'>Enroll and get instant access to the 150 handpicked DSA questions.</p>
            </div>
        </div>

        <div style={{marginTop: "0px"}} className='glidar'>
            <div style={{background: "linear-gradient(to bottom right, #32d6fb 0%, #5558ed 100%)"}} className='header'>
                <h4>{"Step 2"}</h4>
            </div>
            <div className=''>
                <p className='text'>Practice each question with hints and solutions to sharpen your problem-solving skills.</p>
            </div>
        </div>


        <div style={{marginTop: "0px"}} className='glidar'>
            <div style={{background: "linear-gradient(to bottom right, #32d6fb 0%, #5558ed 100%)"}} className='header'>
                <h4>{"Step 3"}</h4>
            </div>
            <div className=''>
                <p className='text'>Apply these concepts in real interviews to crack FANG and other top tech company interviews with ease.</p>
            </div>
        </div>
</div>



  </div>
        </section>
      )
}

export default HowitWorks
